import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

export function createBffClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}
